import { useEffect, useState } from "react";
import debounce from "lodash/debounce";
// Ensures height doesn't bounce off the page while animating, preventing a scroll bar flicker
const ANIMATION_DISTANCE = 16;
/* TODO: Explore baking this into Popper itself */
export const useDynamicMenuHeight = ({ toggleRef, offset = 0, isFullWidth }) => {
    const [menuMaxHeight, setMenuMaxHeight] = useState();
    const [placementConfig, setPlacementConfig] = useState(getPlacementConfig({ location: "bottom", isFullWidth }));
    const MARGIN = 24 + offset + ANIMATION_DISTANCE;
    useEffect(() => {
        const trigger = toggleRef.current;
        if (!trigger) {
            return;
        }
        const update = () => {
            const { top, bottom } = trigger.getBoundingClientRect();
            const inBoundsTop = Math.max(0, top);
            const inBoundsBottom = Math.max(0, bottom);
            const isAttachedTop = bottom / window.innerHeight > 0.5;
            const nextHeight = (isAttachedTop ? inBoundsTop : window.innerHeight - inBoundsBottom) - MARGIN;
            setPlacementConfig(getPlacementConfig({ location: isAttachedTop ? "top" : "bottom", isFullWidth }));
            setMenuMaxHeight(nextHeight);
        };
        if (process.env.NODE_ENV === "test") {
            // Prevent tests from having to mock debounce
            update();
            window.addEventListener("resize", update);
            window.addEventListener("scroll", update);
            return () => {
                window.removeEventListener("resize", update);
                window.removeEventListener("scroll", update);
            };
        }
        const debouncedUpdate = debounce(update, 120);
        debouncedUpdate();
        window.addEventListener("resize", debouncedUpdate);
        // useCapture is required here or nested scrollable areas will not trigger (DES-3114)
        window.addEventListener("scroll", debouncedUpdate, true);
        return () => {
            debouncedUpdate.cancel();
            window.removeEventListener("resize", debouncedUpdate);
            window.removeEventListener("scroll", debouncedUpdate, true);
        };
    }, [MARGIN, isFullWidth, toggleRef]);
    return {
        menuMaxHeight,
        ...placementConfig
    };
};
const getPlacementConfig = ({ isFullWidth, location }) => {
    const suffix = isFullWidth ? "" : "-start";
    const placementConfigs = {
        top: {
            placement: `top${suffix}`,
            fallbackPlacements: [`bottom${suffix}`]
        },
        bottom: {
            placement: `bottom${suffix}`,
            fallbackPlacements: [`top${suffix}`]
        }
    };
    return placementConfigs[location];
};
